<template>
  <div>
  <header>
    <b-collapse id="navcollapse" v-model="navCollapse">
    <div class="first-nav">
      <img
        class="first-logo"
        src="../assets/img/logo-diario.png"
        alt="Logo cepe" />
      <nav class="first-menu">
        <ul>
          <li 
            v-for="(link, idx) in headerConfig.links" 
            :key="idx">
            <a :href="link.link" class="nav-a">{{ link.title }}</a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="second-nav">
      <img class="second-logo" src="../assets/img/logo.png" alt="" />
      <b-navbar>
        <b-navbar-nav>
          <b-nav-item-dropdown class="menu-nav">
            <template slot="button-content">
              <span class="btn-content"> Olá {{ name }} </span>
            </template>
            <b-dropdown-item v-on:click="redirect('home')"
              >Página Inicial</b-dropdown-item
            >
            <b-dropdown-item 
              v-for="route in routes"
              :key="route.page"
              v-on:click="redirect(route.page)"
              >{{route.title}}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-on:click="logout()">
              <template v-if="tokenExpired()">Login</template>
              <template v-else>Sair</template>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>
    </b-collapse>
  </header>
  <!-- <b-button v-b-toggle.navcollapse class="btn-collapse">
    <b-icon-list></b-icon-list>
  </b-button> -->
  <breadcrumb></breadcrumb>
  </div>
</template>

<style>

header {
  width: 100%;
  padding: 0;
  margin: 0;
}

.first-logo {
  margin-left: 28px;
  width: 182px;
  height: 43px;
}
.first-nav {
  box-sizing: border-box;
  background: #861f1f;
  display: flex;
  border-top: 1px solid black;
  height: 44px;
  font-size: 6px;
  font-family: var(--font-primary);
  width: 100%;
  padding: 0px;
  text-transform: uppercase;
  align-items: center;
  justify-content: space-between;
}
.first-nav nav ul {
  display: flex;
  color: white;
  align-items: right;
  margin: 0 0.2rem 0 7rem;
  justify-content: right;
  padding: 0 0.2rem 0 7rem;
}
.first-nav nav ul li {
  display: inline;
  padding: 0.1rem;
}
.first-nav nav ul li a {
  text-decoration: none;
  font-size: 12px;
  color: #fff;
  padding: 13px 12px;
  text-transform: uppercase;
  transition: all 0.3s ease;
}
.first-nav nav ul li a:hover {
  background: #972929;
}

.second-nav {
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  font-family: var(--font-primary);
}
.logo {
  margin: 1rem 0 2rem 4rem;
}
.second-menu {
  justify-content: center;
  font-size: 15px;
  font-family: var(--font-primary);
  padding: 19px;
  list-style: none;
  float: left;
}

.second-logo {
  margin-left: 3vw;
  margin-top: 17px;
  margin-bottom: 17px;
  height: 74px;
  width: 113px;
  content: url('/imgs/logo-cepe-light.png');
}

.navbar-nav > li {
  margin-right: 50px;
}
.navbar-nav > li > a {
  color: white !important;
  font-size: 1rem !important;
}

.btn-collapse {
  position: relative;
  margin-top: 0 !important;
  margin-right: 14.5px;
  border: 0 !important;
  border-radius: 0 0 7px 7px !important;
  box-shadow: 0 0 0 0 !important;
  padding: 5px 5px 2px 5px !important;
}

.btn-collapse:focus, .btn-collapse:hover {
  background-color: black !important;
}

</style>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'

export default {
  components:{ Breadcrumb },
  name: "nav-header",
  data() {
    return {
      name: "usuário",
      role: "dev",
      refreshKey: 0,
      headerConfig: {
        links: [],
        routes: []
      },
      navCollapse: true,
    };
  },
  created() {
    const user = this.$store.getters["auth/user"];
    const expires = this.$store.getters["auth/token"].expires;
    setTimeout(() => this.refresh(), expires);
    this.name = user.Name;
    this.role = user.Role;
    this.headerConfig = require("../assets/json/headerConfig.json");
  },
  methods: {
    redirect(route) {
      this.$router.push({ name: route }).catch(()=>{});
    },
    tokenExpired() {
      return (
        new Date() > new Date(this.$store.getters["auth/token"].expires * 1000)
      );
    },
    refresh() {
      this.refreshKey += 1;
    },
    compareRoles(roles) {
      return roles.some((r) => r == this.role);
    },
    logout() {
      localStorage.clear();
      this.redirect('login');
    }
  },
  computed: {
    routes: function () {
      return this.headerConfig.routes.filter(
        (r) => this.compareRoles(r.roles) && !this.tokenExpired()
      );
    },
  },
};
</script>
